export default __webpack_public_path__ + "static/media/321.26590b7d.jpg";